
const orderRouter = [
    {
        path: '',
        name: 'order-index',
        redirect: '/order/processing',
        component: () => import(/* webpackChunkName: "about" */ '../views/order/index.vue'),
        children: [
            {
                path: 'processing',
                name: 'order-processing',
                component: () => import(/* webpackChunkName: "about" */ '../views/order/processing.vue')
            },
            {
                path: 'completed',
                name: 'order-completed',
                component: () => import(/* webpackChunkName: "about" */ '../views/order/completed.vue')
            },
            {
                path: 'cancelled',
                name: 'order-cancelled',
                component: () => import(/* webpackChunkName: "about" */ '../views/order/cancelled.vue')
            }
        ]
    }
]
export default orderRouter